import styled from "styled-components";

interface MultiSelectListProps {
  width?: string;
  show: boolean;
}

export const MultiSelectFilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
  margin-bottom: 0.625rem;
`;

export const MultiSelectRowActionFilter = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.625rem;

  button {
    border: 1px solid #bebebe;
    border-radius: 0.3125rem;
    color: #676767;
    padding: 0.1875rem 0.75rem;
    width: auto;
    font-size: 0.6875rem;
  }
`;

export const MultiSelectWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.8125rem;
  border: 0.125rem solid #bebebe;
  min-width: auto;
  border-radius: 0.375rem;
  height: 2.625rem;
  padding-left: 0.625rem;
  position: relative;
`;

export const MultiSelectList = styled.ul<MultiSelectListProps>`
  z-index: 9999 !important;
  background: #fff;
  padding: 1rem;

  min-width: ${({ width }) => width || '100%'};
  min-height: 6.25rem;
  position: absolute;

  top: 40px;
  left: 0;
  box-shadow: 0px 0.25rem 0.5rem rgba(0, 0, 0, 0.1);
  display: ${({ show }) => show ? 'block' : 'none'};

  @media only screen and (max-width: 768px) {
    min-width: auto !important;
  }

  li {
    label {
      line-height: 1rem;
    }
  }
`;

export const ArrowDown = styled.a`
  min-width: 0.75rem;
  max-width: 0.75rem;
  margin-right: 0.625rem !important;

  img {
    transition: all 0.5s ease;
  }

  &.arrow-down-inverse img {
    transform: rotate(180deg);
  }
`;

export const MultiSelectCheckbox = styled.input.attrs({ type: 'checkbox' })`
   &.multiselect-checked {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #ffffff;
    border: 0.125rem solid #bebebe;
    width: 1rem;
    height: 1rem;
    cursor: pointer;
    position: relative;
    display: inline-block;
    margin-right: 0.9375rem;
    outline: none;

    &:after {
      top: 0.0625rem !important;
      left: 0.5625rem !important;
    }

    &:before {
        background: #ffffff !important;
        border: 0.125rem solid #bebebe !important;
        background-color: #ffffff !important;
        width: 1.4375rem;
        height: 1.4375rem;
        top: -6px;
        left: -2px;
      }
    
    &:checked {
      background-color: #ffffff;
      border: 0.125rem solid #bebebe;

      &:before {
        background: #ffffff !important;
        border: 0.125rem solid #bebebe !important;
        background-color: #ffffff !important;
        width: 1.4375rem;
        height: 1.4375rem;
        top: -4px;
        left: 0;
      }
    }
    
    &:checked,
    &:after {
      border: solid #0e4c54 !important;
      border-width: 0 0.125rem 0.125rem 0 !important;
    }

    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
`;

export const MultiSelectOverflow = styled.div`
    overflow-y: auto;
    min-width: auto;
    min-height: 6.25rem;
    max-height: 17.5rem;
`;